import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../assets/img/powered-by-asknicely.png'


const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  "data-test": "agent-say-entering"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "dot dot-1" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "dot dot-2" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "dot dot-3" }, null, -1)
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  "data-test": "agent-say-text"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["aria-label", "aria-selected", "onClick", "innerHTML"]
const _hoisted_13 = ["aria-disabled", "onClick"]
const _hoisted_14 = {
  key: 1,
  class: "asknicely_buttonbar_label"
}
const _hoisted_15 = { class: "label_left" }
const _hoisted_16 = { class: "label_right" }
const _hoisted_17 = {
  key: 0,
  class: "asknicely_buttonbar_label_fivestar"
}
const _hoisted_18 = { class: "label_left" }
const _hoisted_19 = { class: "label_right" }
const _hoisted_20 = ["id"]
const _hoisted_21 = {
  key: 1,
  class: "message user-message"
}
const _hoisted_22 = { class: "bubble" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 0,
  class: "validation-message"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, " ", -1)
const _hoisted_26 = {
  key: 0,
  class: "message user-message"
}
const _hoisted_27 = { class: "bubble" }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "bubble" }, "Click here to reset survey", -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 0,
  class: "network-error"
}
const _hoisted_33 = ["href"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  class: "powered-by-b",
  src: _imports_0,
  alt: "Powered by AskNicely"
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "google" }, [
  /*#__PURE__*/_createTextVNode("This site is protected by reCAPTCHA and the Google "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://policies.google.com/privacy" }, "Privacy Policy"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://policies.google.com/terms" }, "Terms of Service"),
  /*#__PURE__*/_createTextVNode(" apply. ")
], -1)

import {
    computed,
    nextTick,
    onBeforeMount,
    onBeforeUnmount,
    ref,
    watch,
} from 'vue'
import type { Ref } from 'vue'
import snarkdown from 'snarkdown'
import {
    initInlineWidget,
    isCalendlyEvent,
    hasCalendly,
} from '@/utils/calendly'
import {
    sendReply,
    sendReplyDiscreetlyWithRetryOnNetworkFail,
    stillHere,
    finished,
    preloadYearInReviewFinishedPage,
} from '@/api/conversation'
import {
    ConversationSpec,
    ConversationItem,
    ConversationDisplayItem,
    Options,
    ReceiveText,
    ReceiveOption,
    OptionLabels,
    LABEL_LEFT_NPS_DEFAULT,
    LABEL_LEFT_FIVESTAR_DEFAULT,
    LABEL_RIGHT_NPS_DEFAULT,
    LABEL_RIGHT_FIVESTAR_DEFAULT,
    LOOKUP_EMAIL,
    LOOKUP_PHONE,
    TYPE_REVIEW_LINK_BUTTON,
} from '@/entities/conversation'
import {
    initialState,
    proceed,
    transitionDisplay,
    setValues,
    setLabels,
    State as ConversationState,
} from './ConversationState'
import { sleep } from '@/utils/async'
import { answerToNPS, answerToFiveScore, Rating } from '@/domain/NPS'
import { init as initConfetti } from '@/animations/confetti'

import ConversationMessage from './components/ConversationMessage.vue'
import ReceiveTextField from './components/ReceiveTextField.vue'
import { interpolateData } from '@/utils/string'
import qs from 'qs'
import { getCDNUrl } from '@/utils/cdn'
import { debounce, validateEmail, validatePhone } from '@/utils/function'
import { defaultCsatOptions } from '@/transforms/conversation'
import { shuffle } from '@/utils/array'
import { SurveyLinkConfig } from '@/entities/appstore/survey-links'
import ReviewLinkButton from '@/pages/conversation/components/ReviewLinkButton.vue'

declare global {
    interface Window {
        askNicelyInterface: {
            postMessage: (message: string) => void
        }
        ReactNativeWebView: {
            postMessage: (message: string) => void
        }
        webkit: {
            messageHandlers: {
                askNicelyInterface: {
                    postMessage: (message: string) => void
                }
                ReactNativeWebView: {
                    postMessage: (message: string) => void
                }
            }
        }
    }
}

declare const UIkit

/**
 * This survey can run in two contexts:
 *
 * From email link:
 *    - answer and rating are known at mount time
 *    - initial score is automatically sent to the server on load
 *    - any subsequent question that tries to submit the initial score will be ignored (not displayed)
 *
 * From inapp:
 *    - answer is unknown at load time
 *    - response to lead question sends answer to server
 *    - rating is derived from answer received clientside
 */

const STILL_HERE_SECONDS = 60
const AUTO_REFRESH_SECONDS = 10
const STORAGE_KEY = 'asknicely-conversation'
interface Params {
    [key: string]: string
}

interface SavedData {
    state: ConversationState
    lastSaidText: string
    initialised: boolean
}

interface Props {
    preview?: boolean
    params: Params
    spec: ConversationSpec
    browserTracking: boolean
    surveyLinkConfig: SurveyLinkConfig
    csatLabels: Options
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConversationUIApp',
  props: {
    preview: { type: Boolean },
    params: {},
    spec: {},
    browserTracking: { type: Boolean },
    surveyLinkConfig: {},
    csatLabels: { default: () => defaultCsatOptions() }
  },
  emits: ['updatespec'],
  setup(__props: any, { emit: __emit }) {

const RESET_EVENTS = [
    'click',
    'keydown',
    'mousedown',
    'mousemove',
    'scroll',
    'touchstart',
    'touchmove',
]

const calendlyEventWindowSizes = {
    event_type_viewed: '970px',
    date_and_time_selected: '620px',
    event_scheduled: '490px',
}

const receiveInput = async (
    item: ReceiveOption | ReceiveText,
    value: string,
    label: string,
    badgeId?: string,
    index?: number,
    multipleValues?: boolean
) => {
    createReply(item.param, value, label, item.type, badgeId, multipleValues)

    if (value === 'yes' && item.link) {
        nextTick(() => {
            loadCalendlyFrame(item.link, 'calendly-frame-' + index)
        })
    } else {
        await next()
    }
}

const emit = __emit
const debouncedReceiveInput = debounce(receiveInput, 500, true)

const containerRef = ref()

// expected in params
const answerRef: Ref<number | null> = ref(-1)
const firstInteractiveIndex = ref(-1)
const slugRef = ref('')
const logoRef = ref('')
const templateRef = ref('default')
const versionRef = ref(1)
const isFiveScoreRef = ref(false)
const inApp = ref(false)
const currentCalendlyFrame = ref()
const disableConfettiRef = ref(false)
const showFinishedReloadWarning = ref(false)
const refreshSurveyTimer: Ref<NodeJS.Timeout | null> = ref(null)

// transient
const replyText = ref('')
const lastSaidTextRef = ref('')
const answerCount = ref(0)

// persisted to localStorage
const stateRef: Ref<ConversationState> = ref({
    cursor: [],
    display: [],
    labels: {},
    spec: [],
    values: {},
})
const avatar = ref('')
const initialisedRef = ref(false) // has the splash screen been shown?
const showNetError = ref(false) // has there been a network error?
const errorTimeout = ref()

// browser tracking
const hasMouse = ref(false)
const hasKeyBoard = ref(false)
const trackingUrl = ref('')
const cardOptionLabels: Ref<OptionLabels> = ref({})

const validationMessage = ref('')
const textareaBorderClass = ref('grey')

const commentForReviewLink = ref('')

const computedRating = computed(() => {
    const answer = Number(answerRef.value)
    return isFiveScoreRef.value
        ? answerToFiveScore(answer)
        : answerToNPS(answer)
})

const storageKey = computed(() => {
    return `${STORAGE_KEY}/${slugRef.value}/${templateRef.value}/${versionRef.value}`
})

const itemsWithReplies = computed(() => {
    return stateRef.value.display.map((item, index) => {
        if (item.cardType !== 'message' && firstInteractiveIndex.value < 0) {
            firstInteractiveIndex.value = index
        }
        if (item.status !== 'new' && item.type === 'Say') {
            /* We need to transfer label text from the card to a variable as the 'Received Option' card, where the labels
               are displayed, don't have this data. */
            if (item.optionLabels) {
                cardOptionLabels.value = {
                    labelLeft: item.optionLabels?.labelLeft,
                    labelRight: item.optionLabels?.labelRight,
                }
            }
        }
        // Randomize order of options, if random is enabled and item is new
        if (
            item.status === 'new' &&
            item.type === 'ReceiveOption' &&
            item.options.length &&
            item.randomizeOrder
        ) {
            shuffle(item.options)
        }
        return {
            ...item,
            reply: getItemReply(item),
        }
    })
})

const labelLeft = (item) => {
    if (isNps(item)) {
        return cardOptionLabels.value.labelLeft
            ? cardOptionLabels.value.labelLeft
            : getDefaultLeftLabel(props.params.labelLeft)
    }

    if (isFivestar(item)) {
        return props.params.labelLeft
            ? props.params.labelLeft
            : LABEL_LEFT_FIVESTAR_DEFAULT
    }

    return null
}

const labelRight = (item) => {
    if (isNps(item)) {
        return cardOptionLabels.value.labelRight
            ? cardOptionLabels.value.labelRight
            : getDefaultRightLabel(props.params.labelRight)
    }

    if (isFivestar(item)) {
        return props.params.labelRight
            ? props.params.labelRight
            : LABEL_RIGHT_FIVESTAR_DEFAULT
    }

    return null
}

const getDefaultRightLabel = (rightLabel: string | null) => {
    return rightLabel ? rightLabel : LABEL_RIGHT_NPS_DEFAULT
}

const getDefaultLeftLabel = (leftLabel: string | null) => {
    return leftLabel ? leftLabel : LABEL_LEFT_NPS_DEFAULT
}

const props = __props

watch(
    () => props.spec,
    async () => {
        stateRef.value = await initialState(props.spec, props.params) // Reset everything as the conversation has changed
        next()
    }
)

onBeforeUnmount(() => {
    RESET_EVENTS.forEach((rev) =>
        document.removeEventListener(rev, resetTimeout)
    )
})

onBeforeMount(async () => {
    stateRef.value = await initialState([], {})
    await initialiseState()
})

const initialiseState = async () => {
    await load()

    if (!initialisedRef.value) {
        await sleep(1000)
        initialisedRef.value = true
    }

    if (inApp.value) {
        postToParent({
            key: 'conversation_loaded',
        })
    }

    await transition()

    // notify server user is still present
    if (!props.preview) {
        const stillHereInterval = setInterval(() => {
            if (!stateRef.value.finished) {
                stillHere(slugRef.value, STILL_HERE_SECONDS)
            } else {
                clearInterval(stillHereInterval)
            }
        }, STILL_HERE_SECONDS * 1000)

        setupAutoRefresh()
    }

    // handle any calendly completed
    handleCalendlyMessages()

    // send initial score, if not done already and not inApp
    if (
        !stateRef.value.finished &&
        stateRef.value.values.initial_score === undefined &&
        !inApp.value
    ) {
        createReply(
            'initial_score',
            String(answerRef.value),
            String(answerRef.value),
            'ReceiveText'
        )
    }

    // if not already awaiting input on load, move ahead (only when it's not finished)
    if (
        !stateRef.value.finished &&
        (!stateRef.value.node ||
            stateRef.value.node.type.indexOf('Receive') === -1)
    ) {
        await next()
    }

    RESET_EVENTS.forEach((rev) => document.addEventListener(rev, resetTimeout))

    resetTimeout()
}

const isOptionSelected = (item, key) => {
    return item.options.find((option) => option.key === key)?.isSelected
}

const onOptionClicked = (
    item,
    value: string,
    label: string,
    badgeId?: string,
    index?: number
) => {
    if (isMultiSelect(item)) {
        const selectOptionIndex = item.options.findIndex(
            (option) => option.key === value
        )
        const selectOption = item.options[selectOptionIndex]

        selectOption.isSelected =
            'isSelected' in selectOption ? !selectOption.isSelected : true

        // item.options are nested object, so to force reactive, we need to use splice function to replace option
        item.options.splice(selectOptionIndex, 1, selectOption)

        return
    }
    debounce(receiveInput(item, value, label, badgeId, index), 500, true)
}

const hasSelectedOptions = (item) => {
    return item.options.some((option) => option.isSelected)
}

const onMultiSelectDone = (item, index) => {
    const selectedOptions = item.options.filter((option) => option.isSelected)
    if (selectedOptions.length > 0) {
        const values: string[] = [],
            labels: string[] = [],
            badgeIds: string[] = []

        for (const selectedOption of selectedOptions) {
            values.push(selectedOption.key)
            labels.push(selectedOption.value)
            badgeIds.push(selectedOption.badgeId)
        }

        debounce(
            receiveInput(
                item,
                values.join('|'),
                labels.join(','),
                badgeIds.join(','),
                index,
                true
            ),
            500,
            true
        )
    }
}

const receiveTextInput = async (item: ReceiveText) => {
    if (replyText.value.trim() === '') {
        return
    }

    // put contact_lookup validation here
    validationMessage.value = ''
    textareaBorderClass.value = 'grey'
    if (item.extraOption) {
        replyText.value = replyText.value.trim()
        if (
            item.extraOption === LOOKUP_EMAIL &&
            !validateEmail(replyText.value)
        ) {
            validationMessage.value = 'Invalid email'
            textareaBorderClass.value = 'red'
            return
        }
        if (
            item.extraOption === LOOKUP_PHONE &&
            !validatePhone(replyText.value)
        ) {
            validationMessage.value = 'Invalid phone number'
            textareaBorderClass.value = 'red'
            return
        }
    }

    if (item.param === 'comment') {
        commentForReviewLink.value = replyText.value
    }

    await debouncedReceiveInput(item, replyText.value, replyText.value)
}

const getItemText = (item: ConversationDisplayItem): string => {
    let key
    let val
    let reply

    switch (item.type) {
        case 'Say':
            return fillParams(item.value)

        case 'ReceiveText':
            key = item.param
            val = stateRef.value.values[key]
            return val || ''

        case 'ReceiveOption':
            key = item.param
            if (isMultiSelect(item)) {
                val = stateRef.value.values[key]?.split('|') ?? []
                const selectedOptions = item.options
                    .filter((opt) => val.includes(opt.key)) // Filter selected value
                    .map((opt) => opt.value) // Get label column values
                return fillParams(
                    selectedOptions.length > 0 ? selectedOptions.join(', ') : ''
                )
            }
            val = stateRef.value.values[key]
            reply = val && item.options.find((opt) => opt.key === val)
            return fillParams(reply ? reply.value : '')
    }
    return ''
}

const getItemReply = (item: ConversationItem): string | undefined => {
    if (item.type === 'ReceiveOption' || item.type === 'ReceiveText') {
        return stateRef.value.values[item.param]
    }
    return undefined
}

const getOptions = (item: ReceiveOption) => {
    let opts = item.options.map(({ key, value, badgeId, isSelected }) => ({
        key,
        value: fillParams(value) || '0', // because smarty json_encode parses '0' as ''
        badgeId,
        isSelected,
    }))
    return opts
}

// highlight any text before an active Receive, or one with no following item
const shouldHighlight = (idx: number) => {
    const { display } = stateRef.value
    const item = display[idx]
    const following = display[idx + 1]
    const states = ['active', 'entering', 'leaving']

    return (
        (item && item.status && states.indexOf(item.status) > -1) ||
        (following
            ? following.type.indexOf('Receive') === 0 &&
              following.status &&
              states.indexOf(following.status) > -1
            : true)
    )
}

// allow interaction with any widgets before an active Receive
const shouldInteract = (idx: number, firstOnly = false) => {
    const { display } = stateRef.value
    const following = display[idx + 1]

    let firstInteractive = firstInteractiveIndex.value
    if (!firstOnly) {
        firstInteractive = idx
    }

    return following
        ? following.type.indexOf('Receive') === 0 &&
              following.status &&
              following.status !== 'done' &&
              idx === firstInteractive
        : false
}

const isNps = (item: { param?: string; cardType?: string }) => {
    return (
        (item.param && !!item.param.match(/_nps$/)) ||
        (item.cardType && item.cardType == 'nps')
    )
}

const isFivestar = (item: { param?: string; cardType?: string }) => {
    return (
        (item.param && !!item.param.match(/_fivestar$/)) ||
        (item.cardType && item.cardType == 'fivestar')
    )
}

const isMultiSelect = (item) => {
    return 'multiSelect' in item && item.multiSelect
}

const getReferrerUrl = () => {
    return props.params.referrerUrl
}

const getNobranding = () => {
    return props.params.nobranding
}

const loadCalendlyFrame = (link, elementId) => {
    if (!hasCalendly(props.spec)) {
        return
    }

    currentCalendlyFrame.value = document.getElementById(elementId)

    initInlineWidget(link + '?hide_event_type_details=1', elementId)
}

const handleCalendlyMessages = () => {
    if (!hasCalendly(props.spec)) {
        return
    }

    window.addEventListener('message', (e) => {
        if (isCalendlyEvent(e)) {
            currentCalendlyFrame.value.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            })
            const event = e.data.event.substring(9)
            if (calendlyEventWindowSizes[event] !== undefined) {
                currentCalendlyFrame.value.style.height =
                    calendlyEventWindowSizes[event]
            }
            if (e.data.event === 'calendly.event_scheduled') {
                next(true)
            }
        }
    })
}

const handleMouseMove = () => {
    hasMouse.value = true
    addTrackingImage()
}

const handleKeyDown = () => {
    hasKeyBoard.value = true
    addTrackingImage()
}

const addTrackingImage = () => {
    if (!props.browserTracking) {
        return false
    }
    const resolution = window.screen.width + '*' + window.screen.height

    const params: { [key: string]: any } = {}
    params.res = resolution
    if (hasMouse.value) {
        params.mouse = 1
    }
    if (hasKeyBoard.value) {
        params.keyboard = 1
    }

    trackingUrl.value = `/email/trackbrowser/${slugRef.value}?${qs.stringify(
        params
    )}`
}

const isLocalStorageAvailable = () => {
    try {
        localStorage.getItem(storageKey.value)
    } catch {
        return false
    }

    return true
}

const load = async () => {
    // parse initial data from template
    const spec = props.spec
    const params = props.params

    avatar.value = params.avatar
    const {
        slug,
        logo,
        answer,
        inapp,
        isFiveScore,
        template,
        version,
        disableConfetti,
    } = params
    slugRef.value = slug
    logoRef.value = logo
    templateRef.value = template
    versionRef.value = parseInt(version, 10)
    answerRef.value = /^\d+$/.test(answer) ? parseInt(answer, 10) : null
    isFiveScoreRef.value = !!isFiveScore
    inApp.value = !!inapp
    disableConfettiRef.value = !!disableConfetti
    answerCount.value = 0

    // try get data from local storage
    const saved =
        !props.preview &&
        isLocalStorageAvailable() &&
        localStorage.getItem(storageKey.value)

    if (saved) {
        const { state, lastSaidText, initialised } = JSON.parse(
            saved
        ) as SavedData

        if (
            answerRef.value &&
            !(parseInt(state?.values.answer) == answerRef.value)
        ) {
            updateScore({ score: answerRef.value }).then(() => {
                stateRef.value = state
                lastSaidTextRef.value = lastSaidText
                initialisedRef.value = initialised
            })
        } else {
            if (state?.values.conversationSlug) {
                // eslint-disable-next-line
                props.params.conversationSlug = state.values.conversationSlug
            }
            stateRef.value = state
            lastSaidTextRef.value = lastSaidText
            initialisedRef.value = initialised
        }

        // construct initial state manager and save
    } else {
        stateRef.value = await initialState(spec, params)
        const firstSayMessage = stateRef.value.display.find(
            (item) => item.type === 'Say'
        )

        if (firstSayMessage) {
            lastSaidTextRef.value = getItemText(firstSayMessage)
        }
        save()
    }
}

const save = () => {
    if (props.preview || !isLocalStorageAvailable()) {
        return
    }
    const data: SavedData = {
        state: stateRef.value,
        lastSaidText: lastSaidTextRef.value,
        initialised: initialisedRef.value,
    }
    localStorage.setItem(storageKey.value, JSON.stringify(data))
}

const createReply = (
    key: string,
    value: string,
    label: string,
    inputType: string,
    badgeId?: string,
    multipleValues?: boolean
) => {
    if (value.toString().trim() === '') {
        return
    }

    const newValues = { [key]: value }
    const newLabels = { [key]: label ?? value }

    // if in app and it's the lead question,
    // also load it into scope and derive rating
    // and notify parent window
    if (
        inApp.value &&
        isAnswerKey(key) &&
        !stateRef.value.values.hasOwnProperty('initial_score')
    ) {
        const answer = Number(value)
        answerRef.value = answer
        newValues.answer = value
        newValues.rating = computedRating.value
    }

    if (inApp.value && answerCount.value === 0) {
        postToParent({
            key: 'initial_score',
        })
    }
    answerCount.value++

    replyText.value = ''
    stateRef.value = setValues(stateRef.value, newValues) // set locally
    stateRef.value = setLabels(stateRef.value, newLabels)

    if (!props.preview) {
        sendReplyDiscreetlyWithRetryOnNetworkFail(slugRef.value, {
            // don't wait for response - UI is optimistic with no undo on fail
            key,
            value,
            badgeId,
            inputType,
            questionText: isAnswerKey(key) ? '' : lastSaidTextRef.value,
            template: templateRef.value,
            version: versionRef.value,
            answer: answerRef.value,
            multipleValues,
            conversationSlug: props.params.conversationSlug,
        }) // send to server
    }
    save()
}

const updateScore = async (data) => {
    const key = 'update_score'
    const value = String(data.score)

    let response = {}
    let url = new URL(location.href)

    // Handle "preview" score changes. Since we do not have a database entry for preview,
    // we just reload the page with the new score change
    if (url.pathname.includes('email/conversation/preview')) {
        let path = location.href
        window.location.href = path.substr(0, path.lastIndexOf('/') + 1) + value // Replace old score with new score.
        return
    }

    try {
        response = await sendReply(slugRef.value, {
            // we just updated the initial score, wait for result
            key,
            value,
            badgeId: undefined,
            inputType: 'ReceiveText',
            questionText: isAnswerKey(key) ? '' : lastSaidTextRef.value,
            template: templateRef.value,
            version: versionRef.value,
            conversationSlug: props.params.conversationSlug,
        })
    } catch (error) {
        showNetError.value = true
        if (errorTimeout.value) {
            clearTimeout(errorTimeout.value)
        }
        errorTimeout.value = setTimeout(() => {
            showNetError.value = false
        }, 1000)

        return
    }

    answerRef.value = Number(value)

    const newValues = {
        [key]: value,
        answer: answerRef.value ? answerRef.value.toString() : '0',
        rating: isFiveScoreRef.value
            ? answerToFiveScore(answerRef.value)
            : answerToNPS(answerRef.value),
    }

    answerCount.value = 0

    save()

    emit('updatespec', { answer: newValues.answer, spec: response })

    stateRef.value = setValues(stateRef.value, newValues) // Getting the new values set
}

const alert = (message: string, status?: string) => {
    UIkit.notify(message, {
        status,
        timeout: 3000,
        pos: 'top-center',
    })
}

// List of question types that can be used for the inital score. (missing 5 star)
const isAnswerKey = (key: string) => {
    return (
        [
            'initial_score',
            'score_nps',
            'answer',
            'answer_nps',
            'answer_csat',
        ].indexOf(key) > -1
    )
}

const transition = async () => {
    const SECOND_BOX = 1
    for await (const next of transitionDisplay(stateRef.value)) {
        stateRef.value = next
    }

    if (
        stateRef.value.display[stateRef.value.display.length - 1] !==
            undefined &&
        stateRef.value.display[stateRef.value.display.length - 1].status ===
            'active' &&
        'getBoundingClientRect' in (containerRef.value as HTMLDivElement) &&
        (containerRef.value as HTMLDivElement).children.length >= 3
    ) {
        const children = (containerRef.value as HTMLDivElement).children
        const top = children[children.length - 2].getBoundingClientRect().top
        const bottom =
            children[children.length - 1].getBoundingClientRect().bottom
        const paddingY = 100 + (children.length > 3 ? 80 : 0)
        const height = bottom - top + paddingY
        postToParent({
            key: 'set_height',
            value: height,
        })
    }
    save()
}

const next = async (afterCalendly = false) => {
    // move the conversation forward
    stateRef.value = await proceed(stateRef.value)
    save()

    if (stateRef.value.finished) {
        scrollToCurrent(afterCalendly)

        if (!props.preview) {
            await finished(slugRef.value, props.params.conversationSlug)
        }

        await sleep(600)

        const showConfetti =
            !disableConfettiRef.value && computedRating.value === 'promoter'
        if (showConfetti) {
            await throwConfetti()
        } else {
            await sleep(600)
        }

        postToOS('askNicelyDone', 'Success')

        postToParent({
            key: 'finished',
            value: lastSaidTextRef.value,
            showConfetti,
        })

        setupAutoRefresh()

        return
    }

    await transition()

    const { node } = stateRef.value

    // if item is a 'say', immediately go to next. otherwise wait for user input (skip or reply)
    if (!node) {
        return
    } else if (node.type === 'Say') {
        lastSaidTextRef.value = getItemText(node as ConversationDisplayItem)
        await next(afterCalendly)
    } else {
        scrollToCurrent(afterCalendly)
        save()
    }
}

const resetTimeout = () => {
    if (props.surveyLinkConfig.autoRefresh && props.surveyLinkConfig.slug) {
        const interval = props.surveyLinkConfig.timeout ?? STILL_HERE_SECONDS
        if (refreshSurveyTimer.value) {
            clearTimeout(refreshSurveyTimer.value)
        }
        refreshSurveyTimer.value = setTimeout(() => {
            returnToSurveyLink()
        }, interval * 1000)
    }
}

const setupAutoRefresh = () => {
    if (
        stateRef.value.finished &&
        props.surveyLinkConfig.autoRefresh &&
        props.surveyLinkConfig.slug
    ) {
        showFinishedReloadWarning.value = true
        setTimeout(() => {
            returnToSurveyLink()
        }, AUTO_REFRESH_SECONDS * 1000)
    }
}

const returnToSurveyLink = () => {
    window.location.href = '/s/feedback/' + props.surveyLinkConfig.slug
}

// @todo skip()

const scrollToCurrent = (afterCalendly = false) => {
    const agentMessages = document.getElementsByClassName('agent-message')
    const prev = agentMessages[agentMessages.length - 2] // use prev to provide some offset
    if (prev && !afterCalendly && !isInapp() && !props.preview) {
        prev.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
    if (prev && isInapp()) {
        const current = agentMessages[agentMessages.length - 1]
        setTimeout(
            () =>
                current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                }),
            250
        )
    }
}

const isInapp = () => {
    const parameters = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
    })

    return (
        parameters.hasOwnProperty('inapp') ||
        (parameters.template_name && parameters.template_name === 'inapp')
    )
}

const fillParams = (str: string): string => {
    const { values, labels } = stateRef.value
    const replaced = interpolateData(
        str,
        { ...values, ...labels },
        props.params.questionType,
        (value) => {
            return `<ReselectScore v-bind:score=${value} v-bind:questionType="'${props.params.questionType}'" v-bind:interact="interact" v-bind:csatLabels="csatLabels" @updatescore="updateScore"></ReselectScore>`
        },
        props.csatLabels
    )

    return snarkdown(replaced.replace(/\n/gi, '<br/>').trim()) // Replace New Lines and trim.
}

const throwConfetti = async () => {
    const W = window.outerWidth
    const H = window.outerHeight

    const canvas = document.createElement('canvas')
    document.body.appendChild(canvas)
    canvas.style.top = '100px'
    canvas.style.pointerEvents = 'none' // confentti should be non blocking and click through
    await initConfetti(30, canvas)
    document.body.removeChild(canvas)
}

const postToParent = (
    data: { key: string; value?: any; showConfetti?: boolean },
    targetOrigin = '*'
) => {
    window.parent.postMessage(data, targetOrigin)
}

const postToOS = (event, msg) => {
    let data = JSON.stringify({ event: event, msg: msg })
    if (window.webkit != undefined) {
        if (window.webkit.messageHandlers.askNicelyInterface != undefined) {
            window.webkit.messageHandlers.askNicelyInterface.postMessage(data)
        }
        if (window.webkit.messageHandlers.ReactNativeWebView != undefined) {
            window.webkit.messageHandlers.ReactNativeWebView.postMessage(data)
        }
    }
    if (window.askNicelyInterface != undefined) {
        window.askNicelyInterface.postMessage(data)
    }
    if (window.ReactNativeWebView != undefined) {
        window.ReactNativeWebView.postMessage(data)
    }
}

const contactLookupInvalid = (item): boolean => {
    return (
        validationMessage.value != '' &&
        item.extraOption &&
        [LOOKUP_EMAIL, LOOKUP_PHONE].includes(item.extraOption)
    )
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "convo",
    onMousemoveOnce: handleMouseMove,
    onKeydownOnce: handleKeyDown
  }, [
    (trackingUrl.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: trackingUrl.value,
          alt: ""
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (!inApp.value)
      ? (_openBlock(), _createElementBlock("header", {
          key: 1,
          class: _normalizeClass(initialisedRef.value ? '' : 'splash')
        }, [
          _createElementVNode("img", {
            id: "company-logo",
            src: _unref(getCDNUrl)(logoRef.value),
            alt: ""
          }, null, 8, _hoisted_2)
        ], 2))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      ref_key: "containerRef",
      ref: containerRef,
      class: "container"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsWithReplies.value, (item, idx) => {
        return (_openBlock(), _createElementBlock("div", { key: idx }, [
          _createVNode(_Transition, { name: "from-left" }, {
            default: _withCtx(() => [
              (
                            item.status !== 'new' &&
                            item.type === 'Say' &&
                            item.cardType !== _unref(TYPE_REVIEW_LINK_BUTTON)
                        )
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass([
                            'message',
                            'agent-message',
                            { 'current-agent-message': shouldHighlight(idx) },
                        ])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                                'bubble',
                                { 'bubble-typing': item.status === 'entering' },
                            ])
                    }, [
                      (item.status === 'entering')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_7))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                            _createVNode(ConversationMessage, {
                              "csat-labels": props.csatLabels,
                              content: getItemText(item),
                              interact: shouldInteract(idx, true),
                              onUpdatescore: updateScore
                            }, null, 8, ["csat-labels", "content", "interact"])
                          ]))
                    ], 2),
                    (shouldHighlight(idx))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "avatar",
                          src: _unref(getCDNUrl)(avatar.value),
                          alt: ""
                        }, null, 8, _hoisted_9))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true)
            ], undefined, true),
            _: 2
          }, 1024),
          (
                        item.status !== 'new' && item.type === 'ReceiveOption'
                    )
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_Transition, { name: "slide-down" }, {
                  default: _withCtx(() => [
                    (
                                item.reply === undefined || item.reply == null
                            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("div", {
                            class: _normalizeClass({
                                    'option-input': true,
                                    nps: isNps(item),
                                    fivestar: isFivestar(item),
                                    entering: item.status === 'entering',
                                })
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getOptions(item), ({
                                        value,
                                        key,
                                        badgeId,
                                        isSelected,
                                    }) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: value,
                                class: _normalizeClass({
                                        'option-item': true,
                                        'option-item-selected': isSelected,
                                    }),
                                "aria-label": value,
                                role: "option",
                                "aria-selected": isSelected,
                                onClick: 
                                        () =>
                                            onOptionClicked(
                                                item,
                                                key,
                                                value,
                                                badgeId,
                                                idx
                                            )
                                    ,
                                innerHTML: fillParams(value)
                              }, null, 10, _hoisted_12))
                            }), 128)),
                            (isMultiSelect(item))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass([
                                        'multi-select-options-done-button',
                                        { disabled: !hasSelectedOptions(item) },
                                    ]),
                                  "aria-label": "Done selecting options",
                                  "aria-disabled": !hasSelectedOptions(item),
                                  onClick: () => onMultiSelectDone(item, idx)
                                }, " Done ", 10, _hoisted_13))
                              : _createCommentVNode("", true),
                            (isNps(item))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createElementVNode("div", _hoisted_15, _toDisplayString(labelLeft(item)), 1),
                                  _createElementVNode("div", _hoisted_16, _toDisplayString(labelRight(item)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2),
                          (isFivestar(item))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, _toDisplayString(labelLeft(item)), 1),
                                _createElementVNode("div", _hoisted_19, _toDisplayString(labelRight(item)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], undefined, true),
                  _: 2
                }, 1024),
                _createVNode(_Transition, { name: "from-right" }, {
                  default: _withCtx(() => [
                    (item.link && item.reply === 'yes')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: `calendly-frame-${idx}`,
                          class: "calendly-frame"
                        }, null, 8, _hoisted_20))
                      : (item.reply !== undefined)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, _toDisplayString(getItemText(item).trim()), 1)
                          ]))
                        : _createCommentVNode("", true)
                  ], undefined, true),
                  _: 2
                }, 1024)
              ]))
            : _createCommentVNode("", true),
          (
                        item.status !== 'new' &&
                        item.type === 'ReceiveText' &&
                        item.param !== _unref(TYPE_REVIEW_LINK_BUTTON)
                    )
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createVNode(_Transition, { name: "slide-down" }, {
                  default: _withCtx(() => [
                    (item.reply === undefined)
                      ? (_openBlock(), _createBlock(ReceiveTextField, {
                          key: item.param,
                          modelValue: replyText.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((replyText).value = $event)),
                          "should-focus": !_ctx.preview,
                          "border-class": textareaBorderClass.value,
                          onSubmitReplyText: ($event: any) => (receiveTextInput(item))
                        }, null, 8, ["modelValue", "should-focus", "border-class", "onSubmitReplyText"]))
                      : _createCommentVNode("", true)
                  ], undefined, true),
                  _: 2
                }, 1024),
                (contactLookupInvalid(item))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("span", null, _toDisplayString(validationMessage.value), 1),
                      _hoisted_25
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_Transition, { name: "from-right" }, {
                  default: _withCtx(() => [
                    (item.reply)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, _toDisplayString(getItemText(item).trim()), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], undefined, true),
                  _: 2
                }, 1024)
              ]))
            : _createCommentVNode("", true),
          (item.param === _unref(TYPE_REVIEW_LINK_BUTTON))
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createVNode(ReviewLinkButton, {
                  item: item,
                  comment: commentForReviewLink.value,
                  slug: slugRef.value,
                  finished: stateRef.value.finished,
                  onLoad: next
                }, null, 8, ["item", "comment", "slug", "finished"])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (
                        showFinishedReloadWarning.value && props.surveyLinkConfig.slug
                    )
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", {
                  class: "message app-message",
                  onClick: returnToSurveyLink
                }, _hoisted_31)
              ]))
            : _createCommentVNode("", true)
        ], undefined, true),
        _: 1
      })
    ], 512), [
      [_vShow, initialisedRef.value]
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (showNetError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, "·"))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    }),
    _createElementVNode("footer", null, [
      (!getNobranding())
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            id: "asknicely-logo",
            href: getReferrerUrl(),
            target: "_blank"
          }, _hoisted_35, 8, _hoisted_33))
        : _createCommentVNode("", true),
      _hoisted_36
    ])
  ], 32))
}
}

})